import moment from 'moment';

class ViewInvoicesModalController {
  constructor($scope, $uibModalInstance, $timeout) {
    "ngInject";

    this.name = 'ViewInvoicesModal';
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$timeout = $timeout;

    // Get the invoices, labor rate, and pop rate from the modal instance
    const invoices = $uibModalInstance.invoices || [];
    $scope.laborRate = $uibModalInstance.laborRate || {};
    $scope.popRate = $uibModalInstance.popRate || {};

    // Group invoices by charge code and format as comma-separated string
    const groupedByChargeCode = {};
    invoices.forEach(function(invoice) {
      const chargeCodeName = invoice.chargeCodeName || 'N/A';
      if (!groupedByChargeCode[chargeCodeName]) {
        groupedByChargeCode[chargeCodeName] = {
          chargeCodeName: chargeCodeName,
          invoices: []
        };
      }
      groupedByChargeCode[chargeCodeName].invoices.push(invoice);
    });

    // Convert to array and format invoices as comma-separated string
    $scope.groupedInvoices = Object.keys(groupedByChargeCode).map(function(key) {
      const group = groupedByChargeCode[key];
      const formattedInvoices = group.invoices.map(function(invoice) {
        const invoiceNumber = invoice.invoiceNumber || invoice.number || 'N/A';
        const invoiceDate = invoice.invoiceDate ? moment(invoice.invoiceDate).format('MM/DD/YYYY') : 'N/A';
        return invoiceNumber + ' (' + invoiceDate + ')';
      });
      return {
        chargeCodeName: group.chargeCodeName,
        invoicesFormatted: formattedInvoices.join(', ')
      };
    });

    // Simulate a click on the table when modal loads to close xeditable in parent window
    $timeout(function() {
      var clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
      document.body.dispatchEvent(clickEvent);
    }, 0);

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.proceed = function () {
      $uibModalInstance.close('proceed');
    };
  }
}

export default ViewInvoicesModalController;




// WEBPACK FOOTER //
// ./client/common/modals/viewInvoicesModal/viewInvoicesModal.controller.js